var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFrame3({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 89,
    height: 88,
    viewBox: "10 0 89 88",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_dd_185_367)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 11.5,
    y: 7,
    width: 66,
    height: 66,
    rx: 10,
    fill: "#FF0D37"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_185_367)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.5 34.5922H26.5593V39.804H23.5V34.5922Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.0255 48.9402V25.303L56.8049 26.622C50.7505 29.1017 44.4712 30.7581 38.0488 31.5767V42.6655C44.4702 43.4841 50.7482 45.1405 56.8022 47.6201L60.0255 48.9402Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.0492 31.1951L62.4867 30.6327V43.6105L63.0492 43.0481C66.3169 39.7802 66.3169 34.463 63.0492 31.1951Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.6392 54.697H37.5684L34.5431 44.7853C32.842 44.642 31.1248 44.5584 29.4218 44.5354L32.6392 54.697Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.0204 32.1739V42.0683C31.2226 42.0807 33.4126 42.1903 35.5876 42.3941V31.8481C33.4125 32.0519 31.2225 32.1614 29.0204 32.1739Z",
    fill: "white"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_dd_185_367",
    x: 0.5,
    y: 0,
    width: 88,
    height: 88,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_185_367"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 3,
    operator: "dilate",
    in: "SourceAlpha",
    result: "effect2_dropShadow_185_367"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.04 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_185_367",
    result: "effect2_dropShadow_185_367"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow_185_367",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_185_367"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 42,
    height: 42,
    fill: "white",
    transform: "translate(23.5 19)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFrame3);
export default __webpack_public_path__ + "static/media/Frame3.921bd2792b389114a3f40eac8c6b28d5.svg";
export { ForwardRef as ReactComponent };